import { useaxios } from "../../../../utils/useaxios";
export default (project_income_name, project_income_amount, project_income_date, project_income_invoice, project_income_note, project_income_id) => setloading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    setloading(true);
    useaxios('project_income/update.php', { project_income_name, project_income_amount, project_income_date, project_income_invoice, project_income_note, project_income_id }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
        } else {
            // clear();
        }
        setloading(false);
    });
}